<template>
    <v-container style="margin-right: 0px;margin-left: 0px; margin-top: 20px; width: 100%;">
        <v-layout row wrap justify-center>
            <h2 style="color:#000349">INDIVIDUALES</h2>
        </v-layout>
        <v-layout row wrap justify-center>
            <v-flex xs12 md10>
                <v-data-table :items="tableIndividuales" :headers="headersSectionDetailsLines" class="table"
                    rows-per-page-text="100" hide-actions>
                    <template slot="items" scope="props">
                        <tr :active="props.selected" @click="props.selected = !props.selected">
                            <td :class="'text-xs-center cut-text'">
                                {{  props.item['SemanaComercial']   }}</td>
                            <td :class="'text-xs-center cut-text'">
                                {{ Number(props.item['PresupuestoN1']).toLocaleString(undefined, {minimumFractionDigits: 2})  }}</td>
                            <td :class="'text-xs-center cut-text'">
                                {{ Number(props.item['IngresoEficiente']).toLocaleString(undefined, {minimumFractionDigits: 2}) }}</td>
                            <td
                                :class="(parseFloat(props.item['PorcentajeCumplimiento']) >= 100 ? ('text-xs-center cut-text colorGreentd') : 'text-xs-center cut-text colorMoradotd')">
                                {{ props.item['PorcentajeCumplimiento'] }} %</td>
                            <td :class="'text-xs-center cut-text'">
                                {{props.item['Bonifica'] }}</td>
                            <td :class="'text-xs-center cut-text'">
                                {{ Number(props.item['PresupuestoN2']).toLocaleString(undefined, {minimumFractionDigits: 2}) }}</td>
                            <td
                                :class="(parseFloat(props.item['PorcentajeCumplimiento2']) >= 100 ? ('text-xs-center cut-text colorGreentd') : 'text-xs-center cut-text colorMoradotd')">
                                {{Number(props.item['PorcentajeCumplimiento2']).toLocaleString(undefined, {minimumFractionDigits: 2})  }}%
                            </td>
                            <td :class="'text-xs-center cut-text'">
                                {{props.item['Bonifica2']  }}</td>

                        </tr>
                    </template>
                    <template slot="no-data">
                        <div>{{ $t('message.noRecords') }}</div>
                    </template>
                </v-data-table>

            </v-flex>
        </v-layout>

    </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    props: ['tableIndividuales'],
    methods: {
    },
    computed: {
        ...mapGetters(["agency", "userProfile", "agencyId"]),

    },
    data() {
        return {

            headersSectionDetailsLines: [
                {
                    align: "center",
                    sortable: false,
                    text: "Semana Comercial",
                    value: "SemanaComercial",
                    width: "18%",
                    class: "table-header-bono"

                },
                {
                    align: "center",
                    sortable: false,
                    text: "Presupuesto N1",
                    value: "PresupuestoN1",
                    width: "14%",
                    class: "table-header-bono"
                },
                {
                    align: "center",
                    sortable: false,
                    text: "Ingreso Eficiente",
                    value: "IngresoEficiente",
                    width: "14%",
                    class: "table-header-bono"
                },
                {
                    align: "center",
                    sortable: false,
                    text: "% De Cumplimiento",
                    value: "PorcentajeCumplimiento",
                    width: "14%",
                    class: "table-header-bono"
                },
                {
                    align: "center",
                    sortable: false,
                    text: "Bonifica",
                    value: "Bonifica",
                    width: "14%",
                    class: "table-header-bono"
                },
                {
                    align: "center",
                    sortable: false,
                    text: "Presupuesto N2",
                    value: "PresupuestoN2",
                    width: "14%",
                    class: "table-header-bono"
                },
                {
                    align: "center",
                    sortable: false,
                    text: "% de Cumplimiento",
                    value: "PorcentajeCumplimiento2",
                    width: "14%",
                    class: "table-header-bono"
                },
                {
                    align: "center",
                    sortable: false,
                    text: "Bonifica",
                    value: "Bonifica2",
                    width: "14%",
                    class: "table-header-bono"
                }
            ]


        }
    }

}
</script>
<style lang="scss" >
$header-table-Bonos: #000349;
$principal-items: #000349 !default;
$grayColor: #dddddd !default;
$colorBlueTd: #a4cde8;
$colorRedTd: #e5a2c3;
$coloryellowTd: #fffb89;
$whiteColor: white;
$colorGreenTd: #a4d1a0;
$colorMoradoTd: #e5a2c3;
$colorNaranjaTd: #e49c73;

.colorGreentd {
    background-color: $colorGreenTd;
}

.colorMoradotd {
    background-color: $colorMoradoTd;
}

.colorNaranjatd {
    background-color: $colorNaranjaTd;
}

.v-label.v-label--active.theme--light.white--text {
    color: $principal-items;
    caret-color: #fff !important;
}

.white--text {
    /* color: #fff !important; */
    color: $principal-items !important;
    caret-color: #fff !important;
}

table tr>td:first-child {
    border-left: 1px solid $grayColor;
    color: $principal-items;
    font-size: medium;
}

.table {
    border: 1px solid $grayColor;
    background-color: transparent !important;
}

.v-table tr:hover:not(.v-table__expanded__content) {
    background: transparent !important;
}

.table th+th {
    border-left: 1px solid $grayColor;
}

.table td+td {
    border-left: 1px solid $grayColor;
}

.table-header-bono {
    background-color: $header-table-Bonos;
}

.theme--light .v-table thead th {
    color: $whiteColor;
    font-size: 14px;
}

.colorbluetd {
    background-color: $colorBlueTd;
}

.colorRedtd {
    background-color: $colorRedTd;
}

.coloryellowtd {
    background-color: $coloryellowTd;
}

.colorwhitetd {
    background-color: white;
}

@media only screen and (min-width: 1264px) {
    .container {
        max-width: 100%;
    }

}
</style>